import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {HashMap, TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-coverage-tab-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe],
  templateUrl: './coverage-tab-header.component.html',
})
export class CoverageTabHeaderComponent {
  readonly titleKey = input.required<string>();
  readonly titleParams = input<HashMap>({});
  readonly subtitleKey = input('');
}
